module.exports = __webpack_public_path__ + "static/python-be04bb1a0822ee1a3dcddd7538cb1c47.png";